import { IResponse, ICustomer } from '@signal/asp-data-commons';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {map, switchMap} from 'rxjs/operators';
import {environment, countryCd} from './util.service';
import {selectDealerCode} from '../../store/dealer/dealer.selectors';
import {Store} from '@ngrx/store';
import {DealerState} from '../../store/dealer/dealer.reducer';

@Injectable({
    providedIn: 'root'
})
export class SearchCustomersService {
    private apiRoot: string;

  constructor(private readonly http: HttpClient,
              private readonly dealerState: Store<DealerState>) {
    this.apiRoot = environment.aspAppointmentApi;
    }
    
    getCustomers(firstName: string = '', lastName: string = '', query: string = ''): Observable<IResponse<ICustomer[]>> {
      return this.dealerState.select(selectDealerCode).pipe(switchMap(dealerCode => {
        return this.http.get(`${this.apiRoot}consumer/${dealerCode}/search?firstName=${firstName}&lastName=${lastName}&query=${query}&countryCd=${countryCd}`).pipe(
            map((data: IResponse<ICustomer[]>) => {
                return data;
            })
        )
      }));
    }

}
